module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 12 Farma Pasa - More (gost. Eli Maca).df0a63b2.mp3";